export const useCrypto = () => {
  const cryptoStore = useCryptoStore();
  const { isLoading, cryptoList, hasError } = storeToRefs(cryptoStore);

  async function fetchCryptoList() {
    isLoading.value = true;
    hasError.value = false;

    try {
      const { ApiService } = useApiService();

      await ApiService.get<Crypto.Asset[]>('/crypto/all')
        .then(({ data }: any) => {
          cryptoList.value = data;
        })
        .catch((error: any) => {
          hasError.value = true;
          console.error('useCrypto: error when fetching crypto list', error);
        })
        .finally(() => {
          isLoading.value = false;
        });
    } catch (err) {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    hasError,
    cryptoList,
    fetchCryptoList,
  };
};
